export const omit = <T, K extends keyof T>(prop: K, { [prop]: excluded, ...rest }: T) => rest;
